import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/BaseElementsCSS/BaseElementsDesktop.css';
import '../../css/BaseElementsCSS/BaseElementsPhone.css';
import '../../css/BaseElementsCSS/BaseElementsTablet.css';
import {useNavigate} from 'react-router-dom';
import {useContext, useEffect, useState} from 'react';
import Instructions from '../../baseElements/Instructions'
import BubbleChoice from '../../baseElements/BubbleChoice';
import axios from 'axios';
import {activity_palettes} from '../../themes';
import TopBar from '../../baseElements/TopBar';
import ConfirmButton from "../../baseElements/ConfirmButton";
import SadFeedback from "../../baseElements/SadFeedback";
import HappyFeedback from "../../baseElements/HappyFeedback";
import NextExerciseButton from "../../baseElements/NextExerciseButton";
import SolutionButton from "../../baseElements/SolutionButton";
import AnimationOverlay from "../../baseElements/AnimationOverlay";
import {checkActivityStatus, createAudioUrl, delay, generateUrl, getExerciseFromDB, getLog, randomizeWords, redirectToExercise, updateCurrentLog} from "../../ActivityManager";
import {AppContext} from "../../AppContext";
import NextQuestionButton from "../../baseElements/NextQuestionButton";
import Spinner from "react-bootstrap/Spinner";

axios.defaults.withCredentials = true;

const INSTRUCTION_TEXT = "Ascolta la sillaba o la parola e trovala tra quelle scritte qui sotto!"

function StimuliAssociation() {
    
    const {activityList, setActivityList, currentActivity} = useContext(AppContext);
    
    const navigate = useNavigate();
    
    const [words, setWords] = useState([]);
    const [maxSteps, setMaxSteps] = useState(0);
    const [stepInfo, setStepInfo] = useState(1);
    const [levelInfo, setLevelInfo] = useState(0);
    
    const [currentPartId, setCurrentPartId] = useState(0);
    const [currentBubbles, setCurrentBubbles] = useState([]);
    const [currentAudioUrl, setCurrentAudioUrl] = useState('');
    const [instructionAudioUrl, setInstructionAudioUrl] = useState('');
    const [loading, setLoading] = useState(true);
    
    const [, setBubblesToExplode] = useState(0);
    const [feedback, setFeedback] = useState('');
    const [isAnimating, setIsAnimating] = useState(false);
    const [answered, setAnswered] = useState(false);
    const [flowButtons, setFlowButtons] = useState({confirm: true, solution: false, nextExercise: false, nextQuestion: false});
    const [exerciseLog, setExerciseLog] = useState({exercise_id: 0, exercise_type: '', progress: 0, actions: []});
    
    const exerciseId = activityList[0][0];
    const exerciseType = activityList[0][1];
    
    function updateButtonFlow(showConfirm, showSolution, showNextExercise, showNextQuestion) {
        setFlowButtons({confirm: showConfirm, solution: showSolution, nextExercise: showNextExercise, nextQuestion: showNextQuestion});
    }
    
    function resetStates() {
        setWords([]);
        setMaxSteps(0);
        setStepInfo(1);
        setCurrentPartId(0);
        setCurrentBubbles([]);
        setIsAnimating(false);
        setAnswered(false);
        setFeedback('');
        setLoading(true);
        updateButtonFlow(true, false, false, false);
    }
    
    useEffect(() => {
        window.history.pushState(null, '', window.location.href);
        
        window.onpopstate = (event) => {
            event.preventDefault();
            navigate('/home'); // Navigate directly to /home
        };
        
        return () => {
            window.onpopstate = null;
        };
    }, [navigate]);
    
    useEffect(() => {
        resetStates();
        loadExercise()
            .then((wordsTemporary) => {
                if (wordsTemporary.length > 0) {
                    syncExerciseWithDB(wordsTemporary).then(() => setLoading(false));
                } else {
                    console.error('No words loaded');
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.error('Error during loading or syncing:', error);
                setLoading(false);
            });
    }, [navigate]);
    
    async function loadExercise() {
        await delay(750);
        return getExerciseFromDB(activityList)
            .then((response) => {
                if (response.success) {
                    const json = JSON.parse(JSON.stringify(response.data[4]));
                    const level = JSON.parse(JSON.stringify(response.data[3]));
                    let id_counter = 0;
                    let wordsTemporary = [];
                    
                    json.associazione_stimolo_scritto.parts.forEach((activity) => {
                        activity.choices.forEach((choice) => {
                            wordsTemporary.push({id: id_counter, choiceText: choice.choice, clicked: false, correct: choice.isCorrect, explosion: false, wrong: false});
                            id_counter++;
                        });
                    });
                    
                    generateUrl("associazione stimolo scritto").then((url) => {
                        setInstructionAudioUrl(url)
                    });
                    
                    setWords(wordsTemporary);
                    setMaxSteps(wordsTemporary.length / 4);
                    setLevelInfo(level);
                    
                    return wordsTemporary;
                } else {
                    console.log(response.errorMess);
                    return [];
                }
            })
            .catch((error) => {
                console.log(error);
                return [];
            });
    }
    
    function syncExerciseWithDB(wordsTemporary) {
        return new Promise((resolve) => {
            getLog(currentActivity).then((response) => {
                if (response.success) {
                    const exercises = JSON.parse(JSON.stringify(response.data))[0];
                    if (exercises.some((exercise) => exercise.exercise_id === exerciseId)) {
                        const exercise = exercises.find((exercise) => exercise.exercise_id === exerciseId);
                        let partId = -4;
                        exercise.actions.forEach((action) => {
                            if (action.part_id > partId) {
                                partId = action.part_id;
                            }
                        });
                        partId += 4;
                        setExerciseLog(exercise);
                        setCurrentPartId(partId);
                        const bubbles = randomizeWords(wordsTemporary.slice(partId, partId + 4));
                        setCurrentBubbles(bubbles);
                        createAudioUrl(bubbles).then(
                            (audioUrl) => {
                                setCurrentAudioUrl(audioUrl);
                            }
                        );
                        setStepInfo(partId / 4 + 1);
                    }
                } else {
                    console.log(response.data.errorMess);
                }
                resolve();
            });
        });
    }
    
    function logUserAction(bubble) {
        const progress = (currentPartId + 4) / words.length * 100;
        const timestamp = new Date().toISOString();
        const newAction = {
            part_id: currentPartId,
            bubbleChosen: bubble.choiceText,
            correct: bubble.correct,
            timestamp: timestamp,
        };
        
        setExerciseLog((prev) => ({
            ...prev,
            exercise_id: exerciseId,
            exercise_type: exerciseType,
            progress: Math.round(progress),
            actions: [...prev.actions, newAction],
        }));
    }
    
    function handleConfirmClick() {
        if (!currentBubbles.find((bubble) => bubble.clicked)) {
            return;
        }
        if (answered)
            return
        setAnswered(true);
        const selectedBubble = currentBubbles.find((bubble) => bubble.clicked);
        const bubble = currentBubbles.find((bubble) => (!bubble.correct && bubble.clicked) || (bubble.correct && !bubble.clicked));
        logUserAction(selectedBubble);
        bubble ? lose() : win();
    }
    
    function handleSolutionClick() {
        checkIfFinished()
        setIsAnimating(true);
        setCurrentBubbles((prevBubbles) =>
                              prevBubbles.map((bubble) =>
                                                  bubble.correct
                                                      ? {...bubble, explosion: true}
                                                      : {...bubble, wrong: false, clicked: false}
                              )
        );
        
    }
    
    function handleNextExerciseClick() {
        const temp = [...activityList];
        temp.shift();
        checkActivityStatus(currentActivity, temp).then(
            (response) => {
                try {
                    setActivityList(response);
                    redirectToExercise(response, navigate);
                } catch (error) {
                    console.log(error);
                }
            }
        );
    }
    
    function handleNextQuestionClick() {
        setFeedback('');
        const nextBubbles = randomizeWords(words.slice(currentPartId + 4, currentPartId + 8));
        setCurrentBubbles(nextBubbles);
        createAudioUrl(nextBubbles).then(
            (audioUrl) => {
                setCurrentAudioUrl(audioUrl);
            }
        );
        
        setStepInfo(stepInfo + 1);
        setCurrentPartId(currentPartId + 4);
        setAnswered(false);
        
        setFeedback('');
        updateButtonFlow(true, false, false, false);
    }
    
    function handleClickOnChoice(id) {
        if (answered)
            return
        setCurrentBubbles((prevBubbles) =>
                              prevBubbles.map((bubble) =>
                                                  bubble.id === id ? {...bubble, clicked: !bubble.clicked} : {...bubble, clicked: false}
                              )
        );
    }
    
    function handleExplodedButton() {
        setBubblesToExplode((prevCount) => {
            const newCount = prevCount - 1;
            if (newCount <= 0) {
                setIsAnimating(false);
            }
            return newCount;
        });
    }
    
    function checkIfFinished() {
        if (currentPartId >= words.length - 4) {
            updateButtonFlow(false, false, true, false);
        } else {
            updateButtonFlow(false, false, false, true);
        }
    }
    
    function win() {
        setIsAnimating(true);
        setFeedback('happy');
        checkIfFinished();
        const explodingBubblesCount = currentBubbles.filter((bubble) => bubble.correct && bubble.clicked).length;
        setBubblesToExplode(explodingBubblesCount)
        setCurrentBubbles((prevBubbles) =>
                              prevBubbles.map((bubble) =>
                                                  bubble.correct && bubble.clicked
                                                      ? {...bubble, explosion: true}
                                                      : bubble
                              )
        );
    }
    
    function lose() {
        setFeedback('sad');
        setCurrentBubbles((prevBubbles) =>
                              prevBubbles.map((bubble) =>
                                                  bubble.clicked
                                                      ? {...bubble, wrong: true}
                                                      : bubble
                              )
        );
        updateButtonFlow(false, true, false);
    }
    
    useEffect(() => {
        if (exerciseLog.exercise_id !== 0) {
            updateCurrentLog(currentActivity, exerciseLog).then();
        }
    }, [exerciseLog]);
    
    if (loading) {
        return (
            <div className={'generalActivitiesBackground custom-col-12 tablet-custom-col-12'} style={{backgroundColor: activity_palettes.purple.secondary}}>
                <Spinner animation="border" variant="light"/>
            </div>
        );
    }
    
    return (
        <div className={'generalActivitiesBackground custom-col-12 tablet-custom-col-12'} style={{backgroundColor: activity_palettes.purple.secondary}}>
            <AnimationOverlay isAnimating={isAnimating}></AnimationOverlay>
            <div className='generalActivitiesPageContent custom-col-11 tablet-custom-col-11'>
                <div className={`generalActivitiesTopBarArea custom-row ${answered ? "disabledElement" : ""}`}>
                    <TopBar levelInfo={levelInfo} stepInfo={stepInfo} maxSteps={maxSteps}> </TopBar>
                    <Instructions hasAudio={true} instructionText={INSTRUCTION_TEXT} wordAudioUrl={currentAudioUrl} instructionAudioUrl={instructionAudioUrl}></Instructions>
                </div>
                
                <div className={`generalActivitiesGameElementsArea row ${answered ? "disabledElement" : ""}`}>
                    <div className='generalActivitiesFeedbackArea custom-col-2 tablet-custom-col-2'>
                        <SadFeedback feedback={feedback.includes('sad')}></SadFeedback>
                    </div>
                    <div className='generalActivitiesColumnOneColumnLayout custom-col-8'>
                        <div className='generalActivitiesColumnOneRowLayout center'>
                            {currentBubbles.length > 0 &&
                             currentBubbles.map((bubble) => (
                                 <div
                                     key={bubble.id}
                                     className="center col-auto"
                                 >
                                     <BubbleChoice
                                         choiceText={bubble.choiceText}
                                         explosion={bubble.explosion}
                                         wrong={bubble.wrong}
                                         clicked={bubble.clicked}
                                         onClickedOption={() => handleClickOnChoice(bubble.id)}
                                         onExplodedButton={() => handleExplodedButton()}
                                     />
                                 </div>
                             ))}
                        </div>
                    </div>
                    <div className='generalActivitiesFeedbackArea custom-col-2 tablet-custom-col-2'>
                        <HappyFeedback feedback={feedback.includes('happy')}></HappyFeedback>
                    </div>
                
                </div>
                <div className={`generalActivitiesConfirmButtonArea custom-row ${isAnimating ? "disabledElement" : ""}`}>
                    {flowButtons.confirm && <ConfirmButton onClick={handleConfirmClick}/>}
                    {flowButtons.solution && <SolutionButton onClick={handleSolutionClick}/>}
                    {flowButtons.nextExercise && <NextExerciseButton onClick={handleNextExerciseClick}/>}
                    {flowButtons.nextQuestion && <NextQuestionButton onClick={handleNextQuestionClick}/>}
                </div>
            </div>
        
        </div>
    );
}

export default StimuliAssociation;
